import { getEnvVar } from '@jooxter/env';
import { create, StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';
import { JooxterState } from './types';
import { stateFactory, StoreEnum } from './state.factory';

// This store state is just here to override defaults
const rtsmDefaultState = (set: Parameters<StateCreator<JooxterState>>[0]): JooxterState => {
  return stateFactory(set, StoreEnum.rtsm);
};

export const useRtsmCodeStore = getEnvVar('DEV')
  ? create<JooxterState>()(devtools((set) => rtsmDefaultState(set)))
  : create<JooxterState>()((set) => rtsmDefaultState(set));
